import React from "react";
import appstyles from "../styles/app.module.css";
function VideoPlayer({ setIsModal, videotoPLay } ){


    function handleModal(){
        setIsModal(false);
    }

const refPlayer = React.useRef();
    const posterpath = "/files/public/ervideos/videos";
    return(
    <section className={appstyles.modawlrapper}>
   <section className={appstyles.videplayercontainer}>

    <span className={appstyles.closebutton} onClick={ handleModal }>X</span>

       <video
       ref={refPlayer}
       controls
       autoPlay
       src={`${posterpath}${videotoPLay.videopath}${videotoPLay.videoid}.mp4`}
   />





   </section>

    </section>
    )
}
export default VideoPlayer;